import SocialIcons, { PLATFORM_CONFIG, detectPlatform } from './SocialIcons';
export { PLATFORM_CONFIG, detectPlatform };
export default SocialIcons;
